import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import Beta from "@/pages/Beta";
import Legal from "@/pages/Legal";
import Valutazione from "@/pages/Valutazione";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Recensione from "@/pages/Recensione";
import Demo from "@/pages/Demo";
import Agenzie from "@/pages/Agenzie";
import CookieBanner from "@/components/enea/CookieBanner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/enea-specialist" element={<Landing />} />
          <Route path="/home-exchange-copilot-ai" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/beta" element={<Beta />} />
          <Route path="/valutazione" element={<Valutazione />} />
          <Route path="/valutazione/successo" element={<PaymentSuccess />} />
          <Route path="/recensione" element={<Recensione />} />
          <Route path="/demo" element={<Demo />} />
          <Route path="/agenzie" element={<Agenzie />} />
          <Route path="/privacy" element={<Legal type="privacy" />} />
          <Route path="/cookie" element={<Legal type="cookie" />} />
          <Route path="/termini" element={<Legal type="termini" />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" />
    </div>
  );
}

export default App;
